import type { AccountList } from '@/shared/api/graphql/account-lists';
import type { SetState } from 'zustand';
import create from 'zustand';

type OrganizationStarredStoreTypes = {
  starredList: AccountList | null;
  setStarredList: (value: AccountList | null) => void;
};

export const useOrganizationStarredStore = create<OrganizationStarredStoreTypes>((set: SetState<OrganizationStarredStoreTypes>) => ({
  starredList: null,
  setStarredList: (value: AccountList | null) => set(() => ({ starredList: value }))
}));
